exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-profile[data-v-e70e0f7e] {\n  cursor: pointer;\n}", ""]);

// exports
